import { ITransformItem, TransformType } from "@kuika/kuika-cl-model";

export interface AxisConfig {
  min: number;
  max: number;
  step: number;
  precision: number;
  unit: string;
  defaultValue: number;
}

export const MOVE_CONFIG: AxisConfig = {
  min: -500,
  max: 500,
  step: 1,
  precision: 0,
  unit: "px",
  defaultValue: 0
};

export const SCALE_CONFIG: AxisConfig = {
  min: 0,
  max: 3,
  step: 0.01,
  precision: 2,
  unit: "x",
  defaultValue: 1
};

export const ROTATE_CONFIG: AxisConfig = {
  min: -360,
  max: 360,
  step: 1,
  precision: 0,
  unit: "deg",
  defaultValue: 0
};

export const SKEW_CONFIG: AxisConfig = {
  min: -90,
  max: 90,
  step: 1,
  precision: 0,
  unit: "deg",
  defaultValue: 0
};

export const AXIS_CONFIG_BY_TYPE: Record<TransformType, AxisConfig> = {
  move: MOVE_CONFIG,
  scale: SCALE_CONFIG,
  rotate: ROTATE_CONFIG,
  skew: SKEW_CONFIG
};

/**
 * Pure helper extracted from transform-form.tsx so Vitest can import it
 * without dragging the Radix UI / React runtime in. Returns the per-axis
 * defaults that a fresh transform item of a given type should start with.
 */
export const defaultsForType = (
  type: TransformType
): Pick<ITransformItem, "x" | "y" | "z" | "unit" | "uniformScale"> => {
  const cfg: AxisConfig = AXIS_CONFIG_BY_TYPE[type];
  if (type === "skew") {
    return { x: cfg.defaultValue, y: cfg.defaultValue, z: undefined, unit: cfg.unit as ITransformItem["unit"] };
  }
  if (type === "scale") {
    return {
      x: cfg.defaultValue,
      y: cfg.defaultValue,
      z: cfg.defaultValue,
      unit: "none",
      uniformScale: true
    };
  }
  return {
    x: cfg.defaultValue,
    y: cfg.defaultValue,
    z: cfg.defaultValue,
    unit: cfg.unit as ITransformItem["unit"]
  };
};
